import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import rankarsLogo from "../../assets/images/shourbh.png";
import "./user.css";
import ComingSoon from "../pages/ComingSoon";

const plans = [
  {
    name: "NEET Essential",
    type: "Foundational Course",
    features: [
      "Complete class notes for all chapters",
      "Daily practice quizzes",
      "Weekly concept revision",
      "AI doubt solving support",
    ],
    prices: {
      1: 199,
      3: 499,
      6: 899,
      12: 1499,
      24: 2499,
    },
  },
  {
    name: "NEET Advanced",
    type: "Test Series + QBank",
    features: [
      "Full syllabus mock tests",
      "5000+ practice questions",
      "Chapter-wise performance review",
      "Detailed solution videos",
      "AI doubt solving support",
    ],
    prices: {
      1: 299,
      3: 799,
      6: 1399,
      12: 2299,
      24: 3999,
    },
    popular: true,
  },
];

const coursesData = [
  {
    id: 1,
    title: "NEET Full Course",
    subtitle: "Complete exam preparation package",
    description:
      "Live classes, recorded lectures, mock tests, and AI help for every chapter.",
    duration: "12 months",
    lessons: "1000+ videos",
    price: "₹2499",
  },
  {
    id: 2,
    title: "NEET Crash Course",
    subtitle: "Fast revision for last-minute aspirants",
    description:
      "Focused concept revision, previous year questions, and timed practice tests.",
    duration: "3 months",
    lessons: "120+ live sessions",
    price: "₹799",
  },
  {
    id: 3,
    title: "NEET Booster Plan",
    subtitle: "Practice & performance improvement",
    description:
      "Adaptive test series, analytics-driven review, and doubt clearing support.",
    duration: "6 months",
    lessons: "500+ practice tests",
    price: "₹1399",
  },
];


function Courses() {
  const dispatch = useDispatch();
  const [selectedDuration, setSelectedDuration] = useState(1);



  return (
  <ComingSoon type="courses" />
  
  // <div className="learning-wrapper py-5 bg-light">
  //     <div className="container text-center">
  //       {/* Header */}
  //       <div className="mb-5">
  //         <h2 className="fw-bold">
  //           Choose Your <span className="text-primary">NEET Plan</span>
  //         </h2>
  //         <p className="text-muted">
  //           Practice, analyze & clear doubts with AI 🤖
  //         </p>
  //       </div>

  //       {/* Duration Selector */}
  //       <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
  //         {[1, 3, 6, 12, 24].map((month) => (
  //           <button
  //             key={month}
  //             onClick={() => setSelectedDuration(month)}
  //             className={`btn ${
  //               selectedDuration === month
  //                 ? "btn-primary"
  //                 : "btn-outline-primary"
  //             }`}
  //           >
  //             {month} Month
  //           </button>
  //         ))}
  //       </div>

  //       {/* Static Course Data */}
  //       <div className="row justify-content-center mb-5">
  //         {coursesData.map((course) => (
  //           <div key={course.id} className="col-md-6 col-lg-4 mb-4">
  //             <div className="card shadow-sm border-0 h-100" style={{ borderRadius: "20px" }}>
  //               <div className="card-body p-4 d-flex flex-column">
  //                 <h5 className="fw-bold">{course.title}</h5>
  //                 <p className="text-primary mb-2">{course.subtitle}</p>
  //                 <p className="text-muted flex-grow-1">{course.description}</p>
  //                 <div className="d-flex justify-content-between text-muted mb-3">
  //                   <span>{course.duration}</span>
  //                   <span>{course.lessons}</span>
  //                 </div>
  //                 <div className="d-flex align-items-center justify-content-between">
  //                   <strong className="fs-4">{course.price}</strong>
  //                   <button className="btn btn-outline-primary rounded-pill px-4">
  //                     View Course
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>

  //       {/* Plans */}
  //       <div className="row justify-content-center">
  //         {plans.map((plan, index) => (
  //           <div key={index} className="col-md-6 col-lg-4 mb-4">
  //             <div
  //               className={`card shadow-lg border-0 h-100 ${
  //                 plan.popular ? "border border-primary" : ""
  //               }`}
  //               style={{ borderRadius: "20px" }}
  //             >
  //               {plan.popular && (
  //                 <div className="badge bg-primary position-absolute top-0 start-50 translate-middle px-3 py-2">
  //                   Most Popular
  //                 </div>
  //               )}

  //               <div className="card-body text-center p-4 d-flex flex-column">
  //                 <h4 className="fw-bold">{plan.name}</h4>
  //                 <p className="text-muted">{plan.type}</p>

  //                 {/* Price */}
  //                 <h2 className="text-primary my-3">
  //                   ₹{plan.prices[selectedDuration]}
  //                 </h2>
  //                 <p className="text-muted">
  //                   for {selectedDuration} month{selectedDuration > 1 && "s"}
  //                 </p>

  //                 {/* Features */}
  //                 <ul className="list-unstyled text-start my-3 flex-grow-1">
  //                   {plan.features.map((feature, i) => (
  //                     <li key={i} className="mb-2">
  //                       ✅ {feature}
  //                     </li>
  //                   ))}
  //                 </ul>

  //                 {/* CTA */}
  //                 <Link
  //                   to={`/checkout?plan=${plan.name}&duration=${selectedDuration}`}
  //                   className="btn btn-primary w-100 rounded-pill mt-auto"
  //                 >
  //                   Get Started
  //                 </Link>
  //               </div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>

  //       {/* AI Highlight Section */}
  //       <div className="mt-5 p-4 bg-white rounded-4 shadow-sm">
  //         <h5 className="fw-bold">
  //           🤖 Ask Doubts Anytime with <span className="text-primary">Ranker AI</span>
  //         </h5>
  //         <p className="text-muted mb-0">
  //           Stuck on a question? Get instant explanations, concepts, and solutions powered by AI.
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  );
}

export default Courses;